module.exports = __webpack_public_path__ + "img/page_image_2_6.5d62baac.svg";